import React, {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import {Accordion, AccordionTab} from "primereact/accordion";

const EmpAssessmentCard = ({assessmentItem, onSupervisorOpinionChange, optionList}) => {
    const [indicatorList, setIndicatorList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const onOpinionChange = e => {
        const weight = e.currentTarget.value;
        onSupervisorOpinionChange(weight, assessmentItem)
        console.log("Forhad Log"+ weight);
    }

    //console.log(assessmentItem);

    useEffect(() => {
        getIndicator()        
    }, [])

    const getIndicator = () => {
        setIsLoading(true)
        axios.get(BASE_URL + "/api/utility/SelectedAssesmentIndicator/" + assessmentItem.assestmentTitleID)
            .then(response => {
               setIsLoading(false)
                if (response.status === 200) {
                    setIndicatorList(response.data)
                }
            }).catch(ex => {
            setIsLoading(false)
            console.log(ex)
        })
    }

    return (<div className="card mb-2">
        <div className="card-header">
            <h6><strong>{assessmentItem.assestmentName}</strong></h6>
        </div>
        <div className="card-body">
            <Accordion activeIndex={1}>
                <AccordionTab header="Indicators">
                    {isLoading ? <ProgressSpinner style={{width:'50px',height:'50px'}} /> : <ul>
                        {indicatorList.map((value, index) => (<div key={index}>
                            <li style={{listStyle: 'none'}}><b>{value.indicatorSequenceNo}. </b> {value.indicatorTitle}</li>
                        </div>))}
                    </ul>}
                </AccordionTab>
            </Accordion>

            <p className="pOpinion d-none"><b>Employee Opinion:</b> {assessmentItem.opinionName}</p>
            {/* <p>{assessmentItem.userAssestmentOpinionID}</p> */}
            <select className="form-select"
                    defaultValue={assessmentItem.userAssestmentOpinionID}
                    onChange={onOpinionChange}
                    aria-label=".form-select-sm example">
                <option value={-1}>Select Opinion</option>
                {optionList.map((value, index) => <option key={index}
                 value={value.assestmentOpinionID}>{value.title}/{value.titleBangla}({value.weight})</option>)}
            </select>
        </div>
    </div>)
}

export default EmpAssessmentCard